var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isPolicyHolder
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h2", [
                      _c("span", { staticClass: "ti-home" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mx-2" }, [
                        _vm._v(_vm._s(_vm.$t("message.addressList.title")))
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.$t("message.addressList.subtitle")))
                      ])
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.addressInfo) +
                            "\n        "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(Math.ceil(_vm.addresses.length / 3), function(i) {
                return _c(
                  "b-row",
                  { key: i, staticClass: "mt-3" },
                  _vm._l(_vm.addresses.slice((i - 1) * 3, i * 3), function(
                    address
                  ) {
                    return _c(
                      "b-col",
                      { key: address.id, staticClass: "mt-md-4 mt-lg-0" },
                      [
                        _c(
                          "b-link",
                          {
                            staticClass: "address-link",
                            attrs: { to: "/addresses/" + address.id }
                          },
                          [
                            _c(
                              "Infobox",
                              {
                                attrs: {
                                  title: _vm.getTitle(address),
                                  subtitle: _vm.getSubtitle(address),
                                  message: _vm.getMessage(address)
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "infobox-icon ti-home"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                )
              }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [_c("b-col", [_c("router-view")], 1)],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isPolicyHolder
        ? _c("div", [
            !_vm.isEditable
              ? _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("h2", [
                            _c("span", { staticClass: "ti-home" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "mx-2" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.addressList.title"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.addressList.subtitleNonPolicyHolder"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-card", { staticClass: "rounded-0" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.addressInfo) +
                                  "\n        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(Math.ceil(_vm.addresses.length / 3), function(i) {
                      return _c(
                        "b-row",
                        { key: i, staticClass: "mt-3" },
                        _vm._l(
                          _vm.addresses.slice((i - 1) * 3, i * 3),
                          function(address) {
                            return _c(
                              "b-col",
                              {
                                key: address.id,
                                staticClass: "mt-md-4 mt-lg-0"
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "infobox",
                                      {
                                        attrs: {
                                          message: _vm.getMessage(address),
                                          title: _vm.getTitle(address),
                                          subtitle: _vm.getSubtitle(address),
                                          variant: "noHover"
                                        }
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "infobox-icon ti-home"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mt-4" },
                                      [
                                        _c(
                                          "b-col",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.editAddress(address)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.addressDetails.btn.edit"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName:
                                                      "v-b-modal.delete-address-model",
                                                    modifiers: {
                                                      "delete-address-model": true
                                                    }
                                                  }
                                                ],
                                                attrs: { variant: "danger" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.setCurrentAddress(
                                                      address
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.addressDetails.btn.delete"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }
                        )
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-4" },
                      [_c("b-col", [_c("router-view")], 1)],
                      1
                    )
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "10" } },
                          [
                            _c("address-form", {
                              ref: "addressForm",
                              attrs: {
                                address: _vm.getCurrentAddress(),
                                onSubmitFn: _vm.saveAddress
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "text-right px-4",
                            attrs: { cols: "10" }
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "link" },
                                on: { click: _vm.cancel }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.addressDetails.btn.cancel"
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.saveAddress }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t("message.addressDetails.btn.save")
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-address-model",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.addressDetails.modal.title"),
            "ok-title": _vm.$t("message.addressDetails.modal.btn.ok"),
            "cancel-title": _vm.$t("message.addressDetails.modal.btn.cancel")
          },
          on: { ok: _vm.deleteAddress }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.addressDetails.modal.question")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cde2397", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cde2397","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/AddressList.vue
// module id = NHD7
// module chunks = 1